import { TextKey } from '@mews-commander/enums';
import { LocalizedTextTag, OptimusPlainLink } from '@mews-commander/ui';
import { Stack, StackItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { AddressSource } from '../types';

type AddressEditLinkProps = Pick<AddressSource, 'id' | 'addressLine1' | 'addressLine2' | 'onEdit' | 'isPrimary'>;

export const AddressEditLink = ({ addressLine1, addressLine2, isPrimary, onEdit, id }: AddressEditLinkProps) => {
    const handleClick = () => {
        if (!onEdit) return;

        onEdit?.(id);
    };

    return addressLine1 || addressLine2 ? (
        <Stack wrap spacing="50">
            <OptimusPlainLink inherit onClick={handleClick}>
                <Stack vertical>
                    <StackItem>{addressLine1}</StackItem>
                    <StackItem>{addressLine2}</StackItem>
                </Stack>
            </OptimusPlainLink>
            {isPrimary && <LocalizedTextTag textKey={TextKey.IsPrimary} />}
        </Stack>
    ) : (
        <OptimusPlainLink inherit onClick={handleClick}>
            <LocalizedText textKey={TextKey.NoDataAvailable} />
        </OptimusPlainLink>
    );
};
